export default "__VITE_ASSET__D5Ufvma3__"